import { InjectionToken } from '@angular/core';
import { Converter } from '@spartacus/core';
import { CsTicketCauseList } from 'src/app/model/contact-form.model';

export const CS_TICKET_CAUSES_NORMALIZER = new InjectionToken<
  Converter<any, CsTicketCauseList>
>('CsTicketCausesNormalizer');
